module.exports = __webpack_public_path__ + "img/webcam-lighter.f0664427.svg";